import client from 'graphql/client';
import fetchCompanyBenefitTypesQuery from './queries';

const fetchCompanyBenefitTypesGraphql = () =>
  client.query({
    query: fetchCompanyBenefitTypesQuery,
  });

export default fetchCompanyBenefitTypesGraphql;
